@file:OptIn(InternalResourceApi::class)

package retroguide.app.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/retroguide.app.shared.generated.resources/"

@delegate:ResourceContentHash(2_087_901_605)
internal val Res.string.start_current_timer_action: StringResource by lazy {
      StringResource("string:start_current_timer_action", "start_current_timer_action", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10776, 54),
      ))
    }

@delegate:ResourceContentHash(400_113_563)
internal val Res.string.start_question_action: StringResource by lazy {
      StringResource("string:start_question_action", "start_question_action", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10831, 49),
      ))
    }

@delegate:ResourceContentHash(2_019_822_853)
internal val Res.string.submit_answer_action: StringResource by lazy {
      StringResource("string:submit_answer_action", "submit_answer_action", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10881, 56),
      ))
    }

@delegate:ResourceContentHash(1_606_882_950)
internal val Res.string.update_answer_action: StringResource by lazy {
      StringResource("string:update_answer_action", "update_answer_action", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10938, 56),
      ))
    }

@delegate:ResourceContentHash(-146_326_950)
internal val Res.string.voting_ranking_title: StringResource by lazy {
      StringResource("string:voting_ranking_title", "voting_ranking_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10995, 60),
      ))
    }

@delegate:ResourceContentHash(544_520_244)
internal val Res.string.weather_answer_prompt: StringResource by lazy {
      StringResource("string:weather_answer_prompt", "weather_answer_prompt", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11056, 85),
      ))
    }

@delegate:ResourceContentHash(-1_239_696_432)
internal val Res.string.weather_cloudy: StringResource by lazy {
      StringResource("string:weather_cloudy", "weather_cloudy", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11142, 34),
      ))
    }

@delegate:ResourceContentHash(-218_786_892)
internal val Res.string.weather_partly_cloudy: StringResource by lazy {
      StringResource("string:weather_partly_cloudy", "weather_partly_cloudy", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11177, 37),
      ))
    }

@delegate:ResourceContentHash(396_525_649)
internal val Res.string.weather_rainy: StringResource by lazy {
      StringResource("string:weather_rainy", "weather_rainy", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11215, 37),
      ))
    }

@delegate:ResourceContentHash(-1_833_081_283)
internal val Res.string.weather_stormy: StringResource by lazy {
      StringResource("string:weather_stormy", "weather_stormy", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11253, 38),
      ))
    }

@delegate:ResourceContentHash(983_475_494)
internal val Res.string.weather_sunny: StringResource by lazy {
      StringResource("string:weather_sunny", "weather_sunny", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11292, 29),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString2Resources(map: MutableMap<String, StringResource>) {
  map.put("start_current_timer_action", Res.string.start_current_timer_action)
  map.put("start_question_action", Res.string.start_question_action)
  map.put("submit_answer_action", Res.string.submit_answer_action)
  map.put("update_answer_action", Res.string.update_answer_action)
  map.put("voting_ranking_title", Res.string.voting_ranking_title)
  map.put("weather_answer_prompt", Res.string.weather_answer_prompt)
  map.put("weather_cloudy", Res.string.weather_cloudy)
  map.put("weather_partly_cloudy", Res.string.weather_partly_cloudy)
  map.put("weather_rainy", Res.string.weather_rainy)
  map.put("weather_stormy", Res.string.weather_stormy)
  map.put("weather_sunny", Res.string.weather_sunny)
}
